import { Fragment, useState } from "react";
import { champPath, profiles } from "../misc/Static";
import Champ from "../images/Champ";
import Item from "../images/Item";
import MatchArenaDetails from "./MatchArenaDetails";
import calcData from "../memos/calcData";
import calcArena from "../memos/calcArena";
import Tip from "../misc/Tip";
import styles from "./MatchTinyArena.module.css";

export const MatchTinyArena = ({ region, puuid, data, width }) => {
  const [active, setActive] = useState(false);

  const pid = data ? data.puuid.indexOf(puuid) : false;
  const pOrder = calcArena(data.placement);
  const calc = calcData(data, pOrder, pid, profiles.queues);

  const expandMatch = () => {
    setActive(!active);
  };
  return (
    <>
      <div className={styles[calc.result]}>
        <div className={styles.meta}>
          <div>{Math.round(data.duration / 60)} min</div>
          <div>{calc.queue}</div>
          <div>{calc.result.toUpperCase()}</div>
          <div>{calc.time}</div>
        </div>
        <div className={styles[width]}>
          <div className={styles.champcol}>
            <a
              href={
                "https://lolalytics.com/lol/" +
                champPath(data.champion[pid]) +
                "/build/"
              }
            >
              <Champ type="champ50b" id={data.champion[pid]} />
            </a>
            <div className={styles.level}>{data.champLevel[pid]}</div>
          </div>
          <div className={styles.killstats}>
            <div>
              <Tip name="kills">
                <span className={styles.kills}>{data.kills[pid]}</span>
              </Tip>{" "}
              /{" "}
              <Tip name="deaths">
                <span className={styles.deaths}>{data.deaths[pid]}</span>
              </Tip>{" "}
              /{" "}
              <Tip name="assists">
                <span className={styles.assists}>{data.assists[pid]}</span>
              </Tip>
            </div>
            <div className={styles.kda}>
              <Tip name="kda">
                {calc.kda[pid]}
                {calc.kda[pid] !== "PERFECT" && <> KDA</>}
              </Tip>
            </div>
            <div className={styles.kp}>
              <Tip name="kp">{calc.kp[pid]}% KP</Tip>
            </div>
            <div className={styles.multikill}>
              <Tip name="multikill">{calc.multi[pid]} </Tip>
            </div>
          </div>
          <div className={styles.itemsplus}>
            <div>
              {[0, 1, 2, 6, 3, 4, 5].map((item, i) => (
                <Fragment key={item}>
                  {data.items[pid][item] === 0 && (
                    <div className={styles.placeholder24}></div>
                  )}
                  {data.items[pid][item] > 0 && (
                    <Item key={i} type="item24r" id={data.items[pid][item]} />
                  )}
                </Fragment>
              ))}
            </div>
          </div>
          <div className={styles.expand} onClick={expandMatch}>
            <div>{active ? "-" : "+"}</div>
          </div>
        </div>
      </div>
      {active && (
        <MatchArenaDetails
          region={region}
          pid={pid}
          match={data}
          order={pOrder}
          calc={calc}
          width={width}
        />
      )}
    </>
  );
};

export default MatchTinyArena;
